module.exports = __webpack_public_path__ + "img/rigid-material.8855233.svg";